import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      // Show navbar at top of page
      if (currentScrollY < 10) {
        setIsVisible(true);
        setIsScrolled(false);
      } else {
        setIsScrolled(true);
        // Hide on scroll down, show on scroll up
        if (currentScrollY > lastScrollY && currentScrollY > 100) {
          setIsVisible(false);
        } else if (currentScrollY < lastScrollY) {
          setIsVisible(true);
        }
      }
      setLastScrollY(currentScrollY);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    // If we're on careers page and clicking a hash link, go to home first
    if (window.location.pathname === '/careers' && href.startsWith('#')) {
      e.preventDefault();
      window.history.pushState({}, '', '/');
      window.location.href = '/' + href;
      setIsMobileMenuOpen(false);
    }
  };
  const navLinks = [{
    name: 'Challenge',
    href: '#challenge'
  }, {
    name: 'Technology',
    href: '#technology'
  }, {
    name: 'Solution',
    href: '#solution'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Team',
    href: '#team'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 px-4 md:px-8 py-4 transition-all duration-500 ease-in-out 
        ${isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'} 
        bg-white/90 backdrop-blur-md border-b border-gray-200/50 shadow-sm`} data-id="element-56">
      <div className="max-w-7xl mx-auto flex items-center justify-between" data-id="element-57">
        {/* Logo */}
        <a href="/" className="flex items-center gap-3 z-50" data-id="element-58">
          <img src="https://cdn.magicpatterns.com/uploads/pKY5pZDQ7qtqGqJw1WUb21/pimlico-logo.png" alt="Pimlico Trading Logo" className="h-8 w-auto" data-id="element-59" />
          <span className="text-xl font-semibold tracking-tight text-[#1e3a5f] md:hidden lg:inline" data-id="element-60">
            Pimlico Trading
          </span>
          <span className="text-xl font-semibold tracking-tight text-[#1e3a5f] hidden md:inline lg:hidden" data-id="element-61">
            PT
          </span>
        </a>

        {/* Desktop Pill Navigation */}
        <div className="hidden md:flex items-center justify-center space-x-1 bg-gray-50 px-2 py-1.5 border border-gray-300/60 shadow-md" data-id="element-62">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => handleNavClick(e, link.href)} className="px-5 py-2 text-xs font-medium uppercase tracking-wider text-gray-600 hover:text-[#1a1a1a] hover:bg-white hover:shadow-sm transition-all duration-200" data-id="element-63">
              {link.name}
            </a>)}
        </div>

        {/* Right Actions */}
        <div className="hidden md:flex items-center z-50" data-id="element-64">
          <a href="/careers" className="text-xs font-medium uppercase tracking-wider text-gray-600 hover:text-[#1e3a5f] transition-colors" data-id="element-65">
            Careers
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden z-50 p-2 text-[#1a1a1a]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-66">
          {isMobileMenuOpen ? <X data-id="element-67" /> : <Menu data-id="element-68" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && <div className="fixed inset-0 bg-[#fafafa] z-40 flex flex-col items-center justify-center space-y-8 md:hidden" data-id="element-69">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => {
        handleNavClick(e, link.href);
        setIsMobileMenuOpen(false);
      }} className="text-2xl font-semibold text-[#1a1a1a]" data-id="element-70">
              {link.name}
            </a>)}
          <a href="/careers" className="text-sm uppercase tracking-widest text-[#1e3a5f] mt-8" data-id="element-71">
            Careers
          </a>
        </div>}
    </nav>;
}